import React, { useState, useEffect, useRef } from 'react';
import { Swipeable } from 'react-swipeable';
import { SlideWrapper, SlidesContainer, Container, Description, Heading, LeftArrow, LeftArrowWrapper, RightArrow, RightArrowWrapper, DesktopBgWrapper, SectionWrapper, } from './css';
const SlidingWidgetV2 = (widgetData) => {
    const { children, id, cssStyle, isDesktop, } = widgetData;
    const { title, childWidth, description, bkgColor, } = widgetData.params;
    const domRef = useRef(null);
    const domRefChild = useRef(null);
    const [activeSlide, changeSlide] = useState(0);
    const [enableArrows, setRefElement] = useState(true);
    const [arrowVisible, setArrowVisible] = useState({
        left: false,
        right: true,
    });
    const width = childWidth || '50';
    const slides = children;
    const slidesLength = slides.length;
    const getRefElement = () => {
        setRefElement(domRef.current.scrollWidth > domRef.current.offsetWidth);
    };
    const setExtremeLeft = () => {
        setArrowVisible((prev) => (Object.assign(Object.assign({}, prev), { left: false, right: true })));
    };
    const setExtremeRight = () => {
        setArrowVisible((prev) => (Object.assign(Object.assign({}, prev), { right: false, left: true })));
    };
    useEffect(() => {
        var _a;
        const { offsetWidth = 0, scrollWidth = 0 } = (domRef === null || domRef === void 0 ? void 0 : domRef.current) || {};
        const clientWidth = ((_a = domRefChild === null || domRefChild === void 0 ? void 0 : domRefChild.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
        if (activeSlide === 0) {
            setExtremeLeft();
        }
        else if (clientWidth * activeSlide + offsetWidth > scrollWidth) {
            setExtremeRight();
        }
    }, [activeSlide, domRef]);
    const rightClickHandler = () => {
        if ((domRef.current.scrollWidth - domRef.current.scrollLeft) > domRef.current.offsetWidth) {
            setArrowVisible((prev) => (Object.assign(Object.assign({}, prev), { left: true })));
            domRef.current.scrollTo({
                top: 0,
                left: domRefChild.current.clientWidth * (activeSlide + 1),
                behavior: 'smooth',
            });
            changeSlide(activeSlide + 1);
        }
    };
    const leftClickHandler = () => {
        if (activeSlide > 0) {
            setArrowVisible((prev) => (Object.assign(Object.assign({}, prev), { left: true, right: true })));
            domRef.current.scrollBy({
                top: 0,
                left: -domRefChild.current.clientWidth,
                behavior: 'smooth',
            });
            changeSlide(activeSlide - 1);
        }
    };
    useEffect(() => {
        getRefElement();
    }, []);
    return (React.createElement(DesktopBgWrapper, { isDesktop: isDesktop, bkgColor: bkgColor },
        React.createElement(Container, { padding: cssStyle.spacingStyle.padding, isDesktop: isDesktop, bkgColor: bkgColor },
            React.createElement(SectionWrapper, { padding: cssStyle.spacingStyle.padding, isDesktop: isDesktop },
                title && React.createElement(Heading, { titleCss: cssStyle.titleStyle }, title),
                description && (React.createElement(Description, { titleCss: cssStyle.descriptionStyle }, description))),
            React.createElement(Swipeable, { delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: false, trackMouse: false, rotationAngle: 0, style: {
                    height: '90%',
                    position: 'relative',
                } },
                isDesktop && slidesLength > 1 && enableArrows && arrowVisible.left && (React.createElement(LeftArrowWrapper, { isDesktop: isDesktop },
                    React.createElement(LeftArrow, { onClick: leftClickHandler }))),
                isDesktop && slidesLength > 1 && enableArrows && arrowVisible.right && (React.createElement(RightArrowWrapper, { isDesktop: isDesktop },
                    React.createElement(RightArrow, { onClick: rightClickHandler }))),
                React.createElement(SlidesContainer, { isDesktop: isDesktop, className: "disable-scrollbars", id: id, padding: cssStyle.spacingStyle.padding, ref: domRef }, slides.map((slide) => (React.createElement(SlideWrapper, { margin: cssStyle.spacingStyle.interItem.web, width: width, key: id, isDesktop: isDesktop, padding: cssStyle.spacingStyle.padding, ref: domRefChild, className: id }, slide))))))));
};
export default SlidingWidgetV2;
